export default __webpack_public_path__ + "static/media/Speedtest.3817d672.jpg";